import React from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import Swal from "sweetalert2";
import util from "../../utils/miniUtils";
import { showApiError } from "./salesHelpers";

// CANCEL_REASON_MAX_LENGTH de inventory-api
const REASON_MAX_LENGTH = 255;

const validationSchema = Yup.object().shape( {
    reason: Yup.string()
        .trim()
        .required( "El motivo de la cancelación es obligatorio" )
        .max( REASON_MAX_LENGTH, `Máximo ${REASON_MAX_LENGTH} caracteres` ),
} );

// Cancelar un pedido Por enviar (por ejemplo, la pieza no se encontró o está dañada). Solo Admin.
// No reembolsa: después se busca el pago en MercadoPago y se reembolsa ahí, como siempre.
export default function CancelOrderForm( { order, onSaved, onCancel } ) {
    const formik = useFormik( {
        initialValues: { reason: "", restockPieces: false },
        validationSchema,
        onSubmit: cancelOrder,
    } );

    async function cancelOrder( values ) {
        const confirmation = await Swal.fire( {
            title: `¿Cancelar el pedido #${order.orderNumber}?`,
            text: "Esta acción no se puede deshacer. El reembolso se hace aparte, en MercadoPago.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Cancelar pedido",
            confirmButtonColor: "#dc3545",
            cancelButtonText: "Volver",
        } );
        if ( !confirmation.isConfirmed ) return;

        try {
            const body = { reason: values.reason.trim(), restockPieces: values.restockPieces };
            const request = await util.axios.post( `sales/orders/${order.uuid}/cancel`, body );
            const { error, msg } = request.data;
            if ( error ) throw msg;
            util.toast().success( msg );
            onSaved();
        } catch ( e ) {
            showApiError( e );
        }
    }

    const reasonError = ( formik.touched.reason || formik.submitCount > 0 ) && formik.errors.reason;

    return (
        <form onSubmit={formik.handleSubmit} className="mt-2" data-cy="sales-cancel-form">
            <label htmlFor="sales-cancel-reason" className="form-label small mb-0">Motivo de la cancelación</label>
            <textarea
                id="sales-cancel-reason"
                name="reason"
                rows={2}
                className="form-control form-control-sm"
                value={formik.values.reason}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                data-cy="sales-cancel-reason"
            />
            {reasonError && <div className="text-danger small">{formik.errors.reason}</div>}
            <div className="form-check mt-2">
                <input
                    id="sales-cancel-restock"
                    name="restockPieces"
                    type="checkbox"
                    className="form-check-input"
                    checked={formik.values.restockPieces}
                    onChange={formik.handleChange}
                    data-cy="sales-cancel-restock"
                />
                <label htmlFor="sales-cancel-restock" className="form-check-label small">
                    Regresar las piezas al inventario (déjalo sin marcar si la pieza está dañada o no se encontró)
                </label>
            </div>
            <div className="mt-2 d-flex gap-2">
                <button type="submit" className="btn btn-sm btn-danger" disabled={formik.isSubmitting} data-cy="sales-cancel-submit">Cancelar pedido</button>
                <button type="button" className="btn btn-sm btn-secondary" onClick={onCancel} data-cy="sales-cancel-close">Volver</button>
            </div>
        </form>
    );
}
